import { MessagingBackend } from "@whatslly/commons/messagingBackend";
import { inject, injectable } from "inversify";
import { TuvisMessagingDataStore } from "./TuvisMessagingDataStore";
import { MessagingCommands } from "@whatslly/commons/tuvis-messaging/messagingCommands";
import type { SWCommandsTypes } from "../../../services/serviceWorker/cmds";
import { SWCommands, SW_COMMANDS_PREFIX } from "../../../services/serviceWorker/cmds";
import i18n from "../i18n/config";
import { TuvisNotificationsService } from "@whatslly/ui-components/services/TuvisNotificationsStore";

export const serviceWorkerBackend = new MessagingBackend<SWCommandsTypes>(SWCommands, SW_COMMANDS_PREFIX);

@injectable()
export class TuvisMessagingNotificationsService {
  constructor(
    @inject(TuvisMessagingDataStore) private readonly dataStore: TuvisMessagingDataStore,
    @inject(TuvisNotificationsService) private readonly tuvisNotificationsService: TuvisNotificationsService
  ) {
    serviceWorkerBackend.on(SWCommands.GET_CHAT, async (msg) => {
      const chat = this.dataStore.chats.find((chat) => chat.phoneId === msg.phoneNumberId && chat.phone === msg.senderNumber);
      return { _id: chat?._id, displayName: chat?.displayName, lang: i18n.language };
    });
  }

  async init() {
    const subscription = await this.tuvisNotificationsService.getSubscription();
    if (!subscription) return;
    await this.dataStore.wsClient.send(MessagingCommands.REGISTER_NOTIFICATIONS_ENDPOINT, { ...(subscription.toJSON() as any), type: "web-push" });
  }
}
